
import { Component, Prop, Vue } from 'vue-property-decorator';
import FormGroup from '@/UI/components/common/form/FormGroup.vue';
import moment from 'moment';

import VisitCreateForm from "@/form/visits/visitCreate";
import VisitStatus from "@/UI/components/forms/visits/detail/VisitStatus.vue";

import VisitCreateDetailMain from "@/UI/components/forms/visits/create/VisitCreateDetailMain.vue";

@Component({
    components: { FormGroup, VisitCreateDetailMain, VisitStatus},
    methods: { moment }
})
export default class VisitCreateModalForm extends Vue {
    @Prop() form!:  VisitCreateForm;
    current_page: number | 0 = 0;
}
